import {
  CTAButtons,
  CTAButtonsAlt,
} from "../../../../../global/components/Buttons/buttons";
import React, { useState, useEffect } from "react";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import Table from "../../../../Components/Table/Table";
import Pagination from "../../../../Components/Pagination/Pagination";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { TableActions, TableActionsNew } from "../../../../Components/Misc/Actions";
import "./style.css";
import { useTablesState } from "../States/States";
import {
  approvePaymentType,
  declinePaymentType,
  getPaymentType,
  createPaymentType,
  updatePaymentType,
} from "../../../../../../utils/redux/Finance/PaymentSetup/PaymentSetupSlice";
import { FiX, FiArrowLeft } from "react-icons/fi";
import DeclineModal from "../Components/DeclineModal";
import { URL } from "../../../../../../utils/routes";
import RouteLayout from "../../../../Components/Layout/RouteLayout";

// Table Headers format:
let mockHeaders = [
  {
    title: "Name",
    key: "name",
  },
  {
    title: "Initiator",
    key: "initiatorName",
  },
  {
    title: "Date Initiated",
    key: "initiatedDate",
  },
  {
    title: "Status",
    key: "statusEnumText",
  },
  {
    title: "Actions",
    key: null,
  },
];

function convertDate(isoDate) {
  let timestamp = Date.parse(isoDate);
  let jsDate = new Date(timestamp);
  let fDate = new Intl.DateTimeFormat("en-us", {
    dateStyle: "short",
    timeStyle: "short",
  });
  return fDate.format(jsDate);
}

export default function PaymentReqSetupTable() {
  // Filter states
  const [filters, setFilters] = useState([]);
  const [search, setSearch] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [comment, setComment] = useState("");
  const [setupID, setSetupID] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [currentType, setCurrentType] = useState({});
  const [declineStatus, setDeclineStatus] = useState(false);

  //Select states
  const [selectAll, setSelectAll] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const paymentTypes = useSelector(
    (state) => state?.paymentSetup?.paymentTypes
  );

  const formattedData = paymentTypes?.result?.map((type) => {
    return {
      ...type,
      initiatedDate: convertDate(type?.initiatedDate),
    };
  });

  const closeModal = () => {
    setOpenModal(false);
    setComment("");
    setDeclineStatus(false);
  };

  const handleComment = (e) => {
    setComment(e.target.value);
  };

  let mockRowOptions = [
    {
      name: "Edit",
      action: (item) => {
        setCurrentType(item);
        setComment(item?.name);
        setOpenModal(true);
      },
    },
    {
      name: "Approve",
      action: (item) => {
        const payload = {
          id: item?.id,
          status: 0,
        };
        dispatch(approvePaymentType(payload)).then((response) => {
          if (response?.meta?.requestStatus === "fulfilled") {
            dispatch(getPaymentType({ pageSize, pageNumber }));
          }
        });
      },
    },
    {
      name: "Decline",
      action: (item) => {
        const payload = {
          id: item?.id,
          status: 7,
        };
        dispatch(approvePaymentType(payload)).then((response) => {
          if (response?.meta?.requestStatus === "fulfilled") {
            dispatch(getPaymentType({ pageSize, pageNumber }));
          }
        });
      },
    },
    {
      name: "Delete",
      action: (item) => {
        setSetupID(item?.id);
        setDeclineStatus(true);
        setOpenModal(true);
      },
    },
  ];

  const handleCreateType = () => {
    if (currentType?.id) {
      const payload = { id: currentType?.id, name: comment };
      return dispatch(updatePaymentType(payload)).then((response) => {
        // console.log({ response });
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(getPaymentType({ pageSize, pageNumber }));
          setCurrentType({});
          setComment("");
          setOpenModal(false);
        }
      });
    }
    const payload = { name: comment };
    dispatch(createPaymentType(payload)).then((response) => {
      // console.log({ response });
      if (
        response?.meta?.requestStatus === "fulfilled" &&
        response?.payload?.successful
      ) {
        dispatch(getPaymentType({ pageSize, pageNumber }));
        setOpenModal(false);
        setComment("");
      }
    });
  };

  const handleDecline = () => {
    const payload = { id: setupID, comment: comment, enable: true };
    dispatch(declinePaymentType(payload)).then((response) => {
      // console.log({ response });
      if (response?.meta?.requestStatus === "fulfilled") {
        dispatch(getPaymentType({ pageSize, pageNumber }));
        setOpenModal(false);
        setComment("");
        setDeclineStatus(false);
      }
    });
  };

  useEffect(() => {
    dispatch(getPaymentType({ pageSize, pageNumber }));
  }, [pageNumber, pageSize, search, filters, endDate, startDate]);

  /**Select One Action */
  const HandleSelectedItems = (itemId, checked) => {
    setSelectedItems((prevSelectedItems) => {
      if (checked) {
        return [...prevSelectedItems, itemId];
      } else {
        return prevSelectedItems.filter((id) => id !== itemId);
      }
    });
  };

  return (
    <RouteLayout>
      <button
        className="text-customGreen flex items-center gap-2 text-xl"
        onClick={() => {
          navigate(-1);
        }}
      >
        <FiArrowLeft />
        Back
      </button>
      <div className="w-full mt-5">
        {openModal && (
          <DeclineModal hideModal={setOpenModal}>
            <div
              className="bg-white w-full overflow-hidden"
              style={{
                borderTopLeftRadius: "5px",
                borderTopRightRadius: "5px",
              }}
            >
              <header className="w-full py-3 bg-customGreen px-4 flex items-center justify-between">
                <p className="text-white text-baseFont">
                  {declineStatus ? "Reason for Delete" : "Payment Type"}
                </p>
                <button
                  className="text-baseFont text-white"
                  onClick={closeModal}
                >
                  <FiX />
                </button>
              </header>
              {/*main*/}
              <div
                className="flex items-start justify-between gap-3 w-full px-7 py-7"
                style={{ borderBottom: "1px solid #ccc" }}
              >
                <textarea
                  cols={"15"}
                  rows={"5"}
                  placeholder={
                    declineStatus
                      ? "Enter reason..."
                      : "Enter name of payment type..."
                  }
                  onChange={handleComment}
                  value={comment}
                  className="text-xs border border-slate-300 rounded w-full p-2 outline-none focus:ring-0 focus:border-customGreen"
                />
              </div>
              {/*main*/}
              <div className="w-full flex items-center justify-end gap-5 pt-3 px-7">
                <button
                  className="rounded-md py-1 px-4 text-baseFont text-customGreen"
                  style={{ border: "1px solid #305f32" }}
                  onClick={closeModal}
                >
                  Cancel
                </button>
                <button
                  className="bg-customGreen rounded-md py-1 px-4 text-white text-baseFont"
                  style={{ border: "1px solid #305f32" }}
                  onClick={declineStatus ? handleDecline : handleCreateType}
                >
                  Proceed
                </button>
              </div>
            </div>
          </DeclineModal>
        )}
        <div
          className={`${DashboardStyle.dashboard_table_holder} rounded p-10 bg-white `}
        >
          <div className="w-full flex items-center justify-between mb-1">
            <h1 className="text-customGreen text-xl font-semibold">
              Payment Types
            </h1>
            <CTAButtons
              onClick={() => {
                setOpenModal(true);
              }}
            >
              Add Payment Type
            </CTAButtons>
          </div>
          <Table>
            <thead>
              <tr>
                <th>
                  <p>ID</p>
                </th>
                {mockHeaders.map((header) => (
                  <th key={header.key}>{header.title}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <RequestTable
                isLoading={false}
                data={formattedData}
                keys={mockHeaders.map((header) => header.key)}
                selectable={true}
                rowOptions={mockRowOptions}
                // getRequest={()=> {}} // function to get request data
                HandleSelectedItems={HandleSelectedItems}
                selectedItems={selectedItems}
              />
            </tbody>
          </Table>
        </div>

        <Pagination
          last_page={paymentTypes?.totalPages}
          present_page={paymentTypes?.currentPage}
          totalRows={paymentTypes?.totalRows}
          pageSize={pageSize}
          setPageSize={(page) => setPageSize(page)}
          click={(page) => setPageNumber(page)}
        />
      </div>
    </RouteLayout>
  );
}

function RequestTable({
  data,
  keys,
  selectable,
  HandleSelectedItems,
  selectedItems,
  rowOptions,
}) {

  return (
    <>
      {data?.map((item, index) => (
        <tr key={item.id}>
          <td>
            <p>{index + 1}</p>
          </td>
          <td>{item.name}</td>
          <td>{item.initiatorName}</td>
          <td>{item.initiatedDate}</td>
          <td>
            {item.status === 0 && "Approved"}
            {item.status === 1 && "Pending"}
            {item.status === 7 && "Declined"}
          </td>
          <td>
            <TableActionsNew actions={rowOptions.map(option => ({
              name: option.name,
              action: () => option.action(item),
            }))} />
          </td>
        </tr>
      ))}
    </>
  );
}
